import { React } from "react";
import ARControllerUI from "../components/ARControllerUI";
import { XR_MODES } from "../constants";
import Event from "../modules/Event";
import "./WebXRActivation.css";

const WebXRActivation = () => {
  const onClick = () => {
    Event.sendSMEvent(XR_MODES.AR);
  };

  return (
    <div className="WebXRActivation">
      <ARControllerUI />
      <div
        role="button"
        tabIndex={0}
        className="WebXRActivationPlane"
        onClick={onClick}
        onKeyDown={onClick}
      >
        <h3 className="text">Tap to begin AR</h3>
        <div className="spinner" />
      </div>
    </div>
  );
};

export default WebXRActivation;
